{
	"async_pickers": {
		"clear": "Cancella selezione",
		"empty": "Nessun risultato",
		"error": "Caricamento delle opzioni non riuscito",
		"remove": "Rimuovi {{label}}",
		"search": "Cerca opzioni",
		"selected_count_one": "1 selezionato",
		"selected_count_other": "{{count}} selezionati"
	},
	"data_table": {
		"column_menu": {
			"autosize_column": "Adatta larghezza colonna",
			"clear_sort": "Rimuovi ordinamento",
			"hide_column": "Nascondi colonna",
			"no_pin": "Nessun blocco",
			"pin_column": "Blocca colonna",
			"pin_left": "Blocca a sinistra",
			"pin_right": "Blocca a destra",
			"sort_asc": "Ordina crescente",
			"sort_desc": "Ordina decrescente",
			"trigger": "Opzioni colonna {{column}}"
		},
		"column_settings": {
			"drag_handle": "Riordina colonna",
			"no_results": "Nessuna colonna trovata",
			"pin_column": "Blocca {{column}}",
			"pin_left": "Blocca a sinistra",
			"pin_right": "Blocca a destra",
			"reset": "Ripristina",
			"search_placeholder": "Cerca colonne...",
			"show_all": "Mostra tutte",
			"toggle_visibility": "Mostra/nascondi {{column}}",
			"trigger": "Colonne",
			"unpin": "Sblocca"
		},
		"error": "Caricamento dei dati non riuscito",
		"loading_more": "Caricamento...",
		"no_results": "Nessun risultato",
		"pagination": {
			"go_to_page": "Vai a pagina {{page}}",
			"more_pages": "Altre pagine",
			"next": "Successivo",
			"previous": "Precedente",
			"rows_per_page": "Righe per pagina"
		},
		"select_all": "Seleziona tutte le righe",
		"select_row": "Seleziona riga",
		"sort_by": "Ordina per {{column}}"
	},
	"date_picker": {
		"cancel": "Annulla",
		"description": "Scegli una data dal calendario",
		"presets": {
			"last_7_days": "Ultimi 7 giorni",
			"last_month": "Mese scorso",
			"last_year": "Anno scorso",
			"this_month": "Questo mese",
			"this_week": "Questa settimana",
			"this_year": "Quest'anno"
		},
		"submit": "Conferma",
		"title": "Seleziona data"
	},
	"filters": {
		"access": "Accesso",
		"active": "Filtri attivi",
		"catalog": "Catalogo",
		"channel": "Canale",
		"people": "Persone",
		"period": "Periodo",
		"remove": "Rimuovi {{label}}",
		"reset": "Azzera filtri",
		"title": "Filtri",
		"workflow": "Lavorazione"
	},
	"http_errors": {
		"admin_forbidden": "Non hai i permessi per eseguire questa azione amministrativa.",
		"anonymous_sign_in_disabled": "L'accesso anonimo è disabilitato.",
		"anonymous_user_cannot_change_password": "Gli utenti anonimi non possono modificare la password.",
		"anonymous_users_cannot_sign_in_again_anonymously": "Gli utenti anonimi non possono accedere di nuovo in modo anonimo.",
		"auth_credentials_missing": "Effettua l'accesso prima di continuare.",
		"auth_csrf_invalid": "Il token di sicurezza della sessione non è valido. Ricarica e riprova.",
		"auth_email_not_found": "Nessun account trovato con questo indirizzo email.",
		"auth_jwt_invalid": "La sessione di accesso non è valida o è scaduta. Effettua di nuovo l'accesso.",
		"auth_session_issue_failed": "Non è stato possibile completare l'accesso. Riprova.",
		"auth_token_invalid": "La sessione di accesso non è valida o è scaduta. Ricomincia.",
		"backoffice_admin_deleted": "Questo account amministratore è stato eliminato.",
		"backoffice_admin_not_found": "Account amministratore non trovato.",
		"backoffice_auth_credentials_missing": "Effettua l'accesso come admin prima di continuare.",
		"backoffice_change_password_otp_invalid": "Il codice via email non è valido. Riprova.",
		"backoffice_change_password_otp_unavailable": "I codici via email non sono disponibili per modificare questa password admin.",
		"backoffice_csrf_invalid": "Il token di sicurezza della sessione admin non è valido. Ricarica e riprova.",
		"backoffice_email_already_in_use": "Esiste già un account admin con questa email.",
		"backoffice_email_otp_token_invalid": "La sessione di verifica è scaduta. Richiedi un nuovo codice.",
		"backoffice_invalid_email_or_password": "L'email o la password non sono validi.",
		"backoffice_invalid_password": "La password non è valida.",
		"backoffice_invite_invalid": "Questo invito admin non è valido o è scaduto.",
		"backoffice_jwt_invalid": "La sessione admin non è valida o è scaduta. Effettua di nuovo l'accesso.",
		"backoffice_no_change_password_method_available": "Non è disponibile alcun metodo per modificare questa password admin.",
		"backoffice_rate_limited_one": "Troppi tentativi: riprova tra {{count}} minuto.",
		"backoffice_rate_limited_other": "Troppi tentativi: riprova tra {{count}} minuti.",
		"backoffice_reset_password_session_missing": "La sessione di reimpostazione password amministrativa non è presente.",
		"backoffice_reset_password_token_invalid": "Il token di reimpostazione password amministrativa non è valido o è scaduto.",
		"backoffice_self_edit_forbidden": "Non puoi modificare qui il tuo account admin.",
		"backoffice_session_expired": "La sessione admin è scaduta. Effettua di nuovo l'accesso.",
		"backoffice_session_invalid": "La sessione admin non è più valida. Effettua di nuovo l'accesso.",
		"backoffice_session_issue_failed": "Non è stato possibile completare l'accesso. Riprova.",
		"change_password_otp_invalid": "Il codice via email non è valido. Riprova.",
		"change_password_otp_unavailable": "I codici via email non sono disponibili per modificare questa password.",
		"default": "Ops! Qualcosa è andato storto.",
		"email_already_in_use": "Esiste già un account con questa email.",
		"email_otp_token_invalid": "La sessione di verifica è scaduta. Richiedi un nuovo codice.",
		"impersonation_token_invalid": "Questo link di impersonificazione non è valido o è già scaduto.",
		"invalid_code": "Il codice non è valido.",
		"invalid_delete_account_otp": "Il codice di eliminazione account non è valido.",
		"invalid_email_or_password": "Email o password non validi.",
		"invalid_password": "La password non è valida.",
		"maintenance_mode": "Il servizio è temporaneamente in manutenzione.",
		"no_change_password_method_available": "Non è disponibile alcun metodo per modificare questa password.",
		"otp_issuance_throttled": "Troppe richieste di codice. Attendi prima di richiederne uno nuovo.",
		"password_too_long": "La password è troppo lunga.",
		"password_too_short": "La password è troppo breve.",
		"permission_denied": "Il tuo account ha effettuato l'accesso, ma non dispone dei permessi necessari per visualizzare questa pagina.",
		"reset_password_session_missing": "La sessione di reimpostazione password non è presente.",
		"reset_password_token_invalid": "Il token di reimpostazione password non è valido o è scaduto.",
		"session_expired": "La sessione è scaduta. Effettua di nuovo l'accesso.",
		"session_invalid": "La sessione non è più valida. Effettua di nuovo l'accesso.",
		"session_not_found": "Sessione non trovata.",
		"unauthorized": "Non hai effettuato l'accesso. Effettua l'accesso per continuare.",
		"user_banned": "Questo account utente è stato bannato.",
		"user_deleted": "Questo account utente è stato eliminato.",
		"user_not_found": "Utente non trovato.",
		"validation_error": "Alcuni dei dati inseriti non sono validi."
	},
	"infinite_virtual_list": {
		"empty": "Nessun risultato",
		"error": "Caricamento dei dati non riuscito"
	},
	"inline_filter_date": {
		"from": "Da {{date}}",
		"to": "Fino al {{date}}"
	},
	"inline_filters": {
		"clear": "Rimuovi filtro",
		"clear_all": "Rimuovi tutto",
		"clear_label": "Rimuovi filtro: {{label}}"
	},
	"input_password": {
		"hide": "Nascondi password",
		"show": "Mostra password"
	},
	"list_input_search": {
		"clear": "Cancella ricerca",
		"label": "Cerca"
	},
	"query_breadcrumbs": {
		"error": "Errore",
		"no_data": "Dettaglio"
	},
	"sidebar": {
		"close": "Chiudi menu",
		"collapse": "Comprimi menu",
		"expand": "Espandi menu",
		"navigation": "Navigazione principale",
		"open": "Apri menu"
	}
}
